import CloseIcon from "@/components/atoms/svg/icons/CloseIcon";
import { ITagData } from "@/interfaces/IAgentData";
import clsx from "clsx";
import Image from "next/image";
import React from "react";

interface IChipCategoryProps
  extends ITagData,
    Pick<React.HTMLAttributes<HTMLButtonElement>, "className" | "onClick"> {
  isActive?: boolean;
  width?: number;
  height?: number;
  textStyle?: string;
}

const ChipCategory = (props: IChipCategoryProps) => {
  return (
    <button
      className={clsx(
        "flex gap-2 w-auto justify-center items-center rounded-full shadow-md btn-default !h-9 max-h-9 !min-h-0 [&>svg]:!size-[18px] min-[451px]:[&>svg]:!size-5",
        props.className,
        {
          "!border-[#D8C0F7]": props.isActive,
        },
      )}
      type="button"
      onClick={props.onClick}
      aria-label={props.name}
    >
      {props.image && (
        <Image
          src={props.image}
          alt={props.name}
          width={props.width ?? 20}
          height={props.height ?? 20}
        />
      )}
      <p
        className={clsx(
          `${props.textStyle ?? "text-sm"} text-primary font-medium caption-l`,
          props.isActive ? "!text-[#924FE8]" : "text-primary",
        )}
      >
        {props.name}
      </p>
      {props.isActive && <CloseIcon fill="#873DE6" fillOpacity="0.3" />}
    </button>
  );
};
export default ChipCategory;
